import {
  Injectable,
  Injector
} from '@angular/core';

import {
  BaseResourceService
} from './base-resource.service';


@Injectable({
  providedIn: 'root'
})
export class comumService
  extends BaseResourceService<any> {

  constructor(
    protected override injector: Injector
  ) {

    super(
      injector
    );

  }


  registrarAuditoriaDocumentoAnotacao(
    idDocumento:
      string | number
  ) {

    const params = {
      anotacao_documento_id:
        idDocumento
    };


    return this.post(
      params,
      '/anotacoes/registrar-download-anotacao',
      true
    );

  }

}